import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/** Marinblå hover + vit text (ikonerna följer `currentColor` från knappen). */
const HOVER_NAVY =
  "hover:bg-[#1e3a5f] hover:text-white hover:border-[#1e3a5f] hover:shadow-md"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border text-sm font-semibold " +
    "transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 " +
    "focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 " +
    "hover:-translate-y-[1px] active:translate-y-0 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          `bg-primary text-primary-foreground border-transparent shadow-md ${HOVER_NAVY}`,
        destructive:
          `bg-destructive text-destructive-foreground border-transparent shadow-sm ${HOVER_NAVY}`,
        outline:
          `bg-white border-slate-300 text-slate-700 shadow-sm ${HOVER_NAVY}`,
        secondary:
          `bg-secondary text-secondary-foreground border-transparent shadow-sm ${HOVER_NAVY}`,
        ghost:
          `bg-transparent border-transparent text-slate-700 shadow-none ${HOVER_NAVY}`,
        link:
          `border-transparent bg-transparent text-primary underline-offset-4 rounded-md ${HOVER_NAVY} hover:underline`,
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
